import { FormattedMessage } from '@subaio/components'

import { IconHeaderError } from 'components/Icons'
import { SplashScreen } from 'components/Layout'

export const Error = () => (
	<SplashScreen
		title={<FormattedMessage id='error.title' defaultMessage='An unexpected error has occurred' />}
		icon={<IconHeaderError />}
	/>
)
